import React, { useEffect, useState } from 'react';
import Loader from '../../components/loader';
import { Outlet } from 'react-router-dom';
import { getPublicShareProfile } from '../../profile/actions';
import { useActions } from '../../hooks/useActions';
import ErrorBoundary from '../../components/ErrorBoundary';
import MessagesV2 from '../../MessagesV2';

export type PublicShareLayoutProps = {
  showLoading?: boolean;
};

export default function PublicShareLayout({ showLoading }: PublicShareLayoutProps) {
  const [profileLoaded, setProfileLoaded] = useState(false);
  const getPublicShareProfileAction: VoidFunction = useActions(getPublicShareProfile);

  useEffect(() => {
    getPublicShareProfileAction();
    setProfileLoaded(true);
  }, []);

  if (!profileLoaded) {
    return <Loader isLoading={showLoading ?? true} />;
  }

  return (
    <ErrorBoundary>
      <Outlet />
      <MessagesV2 />
    </ErrorBoundary>
  );
}
